import Api from './Api'

const endpoint = 'employees-ranges'

export default class EmployeesRangeService extends Api {

    async all () {
        const response = await this.client.get(`${endpoint}/all`)
        if (response.data) {
            return response.data.map(s => {
                return {
                    value: s.id,
                    text: s.description
                }
            })
        }
        throw new Error('No data')
    }
}